module.exports = __webpack_public_path__ + "static/media/go-smart.2db937ed.jpg";